import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Home.css';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';

export const Home = () => {
    const navigate = useNavigate();
    const { instance, accounts } = useMsal();

    const handleModelClick = async (path) => {
        if (path === '/electro-plating' || path === '/surfactant-optimization' || path === '/electro-plating-rf') {
            try {
                // Prioritize the active account. If not set, use the first available account.
                // NOTE: If multiple users are signed in and none is active, this defaults to the first one.
                const account = instance.getActiveAccount() || accounts[0];

                console.log("Using Account for Token:", account?.username);
                console.log("All Available Accounts:", accounts.map(a => a.username));

                let accessToken = '';

                if (account) {
                    try {
                        const response = await instance.acquireTokenSilent({
                            ...loginRequest,
                            account: account,
                        });
                        console.log("Token acquired silently for:", account.username);
                        accessToken = response.accessToken;
                    } catch (error) {
                        console.warn("Silent token acquisition failed.", error);
                        // Optional: You might want to force login if silent fails, 
                        // but for checking access on click, we might just fail gracefully or ask to login.
                        // For now, let's proceed. If token is empty, backend will 401.
                    }
                } else {
                    console.warn("No active account found.");
                }

                if (!accessToken) {
                    alert('You must be logged in to access this model.');
                    return;
                }

                const response = await fetch(`${process.env.REACT_APP_FUNC_APP_API_BASE_URL}/api/check-access`, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });

                if (response.ok) {
                    navigate(path);
                } else if (response.status === 403) {
                    // Parse the specific error message from the backend if possible
                    const data = await response.json().catch(() => ({}));
                    if (data.message) {
                        alert(data.message);
                    } else {
                        alert('Access denied: You do not have permission to access this model.');
                    }
                } else {
                    alert('Access denied: You do not have permission to access this model.');
                }
            } catch (error) {
                console.error('Error checking access:', error);
                alert('An error occurred while checking access permissions.');
            }
        } else {
            navigate(path);
        }
    };

    return (
        <div className="home-container">
            <div className="models-section">
                <h2 className="models-headline">Models</h2>
                <div className="models-grid">
                    <div
                        className="model-card"
                        onClick={() => handleModelClick('/electro-plating')}
                    >
                        <h3 className="model-title">Electro-Plating Model</h3>
                        <p className="model-description">
                            Advanced simulation for electro-plating processes and optimization.
                        </p>
                    </div>

                    <div
                        className="model-card"
                        onClick={() => handleModelClick('/electro-plating-rf')}
                    >
                        <h3 className="model-title">Electro-plating (RF)</h3>
                        <p className="model-description">
                            Advanced simulation using tree based model for electro-plating processes.
                        </p>
                    </div>

                    <div
                        className="model-card"
                        onClick={() => handleModelClick('/surfactant-optimization')}
                    >
                        <h3 className="model-title">Surfactant Optimization</h3>
                        <p className="model-description">
                            AI/ML modelling for surfactant formulation and type prediction.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};
